import styled from 'styled-components';

export const BackgroundPartnerInfo = styled.div`
    .partner-info {
        padding: 1.25rem;
        margin-top: 1.25rem;
        border: 1px solid #eee;
        border-left-width: .25rem;
        border-left-color: #5bc0de;
        border-radius: .25rem
    }
`;
